import { Button, Col, DatePicker, Divider, Form, message, Row, Select, Typography } from 'antd';
import dayjs from 'dayjs';
import moment, { Moment } from 'moment';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { IListColumn, ISortColumn } from 'src/@types/search-params';
import { getInfoActiveSim } from 'src/api/activeSim';
import TableContent from 'src/components/CTable';
import { getAllDataPackageNew } from 'src/api/register_and_cancel_and_load_package';
import CGridView from 'src/components/CGridView';
import useWindowSize from 'src/hooks/useWindowSize';
import { OpenNewTab } from 'src/shared/common/openNewTab';
import { SimType } from 'src/shared/enum/sim.enum';
import { IOrderStatus } from 'src/shared/interface/package_assigned';
import {
  dataGet,
  exportExcelPost,
  formatPhoneNumber,
  nonAccentVietnamese,
  parseQueryString,
} from 'src/utils';
import { simTypeToText } from 'src/utils/sim.enum';
import {
  getJointSubjectOption,
  getJointSubjectSim,
  getSimStatusBasic,
  getSimStatusOption,
  getUcmCardTypeID,
  listSubscriptionStatusOption,
} from '../../utils';
import { usePermission } from 'src/hooks/usePermission';

import { useAppSelector } from 'src/redux/hook';
const { Option } = Select;

interface FormData {
  simType?: number | string;
  statusSim?: number | string;
  dateRange?: [Moment, Moment];
  search?: string;
  goodCode?: string;
  custType?: string;
  statusIsdn?: string | number;
}

const ActiveSim = () => {
  const size = useWindowSize();
  const location = useLocation();
  const [form] = Form.useForm();
  const [_, setSearchParams] = useSearchParams();
  const { activeKeyId } = useAppSelector((state) => state.global);
  const [dataPackage, setDataPackage] = useState<IOrderStatus[]>([]);
  const [dataSource, setDataSource] = useState();

  const { PERMISSIONS, hasPermission } = usePermission();

  useEffect(() => {
    form.resetFields();
    setDataSource(undefined);
  }, [activeKeyId]);

  const fetchActiveSimInfoData = async (
    params = {
      custType: '',
      statusIsdn: '',
    },
  ) => {
    try {
      const { custType, statusIsdn } = params;
      if (!custType) {
        message.error('Vui lòng chọn đối tượng!');
        setDataSource(undefined);
      } else if (!statusIsdn) {
        message.error('Vui lòng chọn trạng thái thuê bao!');
        setDataSource(undefined);
      } else {
        const res = await getInfoActiveSim(params);
        setDataSource(res);
      }
    } catch (error) {
      setDataSource(undefined);
    }
  };

  useEffect(() => {
    fetchGetPackageAssigned();
  }, []);

  const fetchGetPackageAssigned = async () => {
    await getAllDataPackageNew().then((res: any) => {
      if (res) {
        const dataPackage: IOrderStatus[] = [{ value: '-1', label: 'Tất cả' }];
        res?.map((item: any) => {
          dataPackage?.push({
            label: item?.mbfName ?? '',
            value: item?.mbfCode ?? '',
          });
        });
        setDataPackage(dataPackage);
      }
    });
  };

  const columns: IListColumn[] = [
    { name: 'STT', fieldName: 'index', align: 'center', isHideSort: true, width: 50 },
    {
      name: 'SĐT',
      fieldName: 'isdn',
      align: 'center',
      width: 150,
      isHideSort: true,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {record.isdn ? '0' + formatPhoneNumber(record.isdn) : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Serial',
      fieldName: 'serial',
      align: 'center',
      width: 150,
      isHideSort: true,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text
            className={
              'underline whitespace-nowrap cursor-pointer bg-transparent border-transparent text-blue-400 font-semibold'
            }
            onClick={() => handleDetailActiveSim(record)}
          >
            {record?.serial}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Loại SIM',
      fieldName: 'simType',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {simTypeToText(Number(record.simType) + 1)}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Ngày gán gói ban đầu',
      fieldName: 'kittingDate',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {dataGet(record, 'kittingDate') ? dataGet(record, 'kittingDate').split(' ')[0] : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Gói cước ban đầu',
      fieldName: 'goodCode',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return <Typography.Text className='Text'>{dataGet(record, 'goodCode')}</Typography.Text>;
      },
    },
    {
      name: 'Tên gói cước ban đầu',
      fieldName: 'goodName',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {
              dataPackage.find((predicate) => predicate.value === dataGet(record, 'goodCode'))
                ?.label
            }
          </Typography.Text>
        );
      },
    },
    {
      name: 'Ngày kích hoạt',
      fieldName: 'activeDate',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {dataGet(record, 'activeDate') ? dataGet(record, 'activeDate').split(' ')[0] : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Mã hồ sơ DN',
      fieldName: 'companyCode',
      isHideSort: true,
      align: 'center',
    },
    {
      name: 'Tên hồ sơ DN',
      fieldName: 'companyName',
      isHideSort: true,
      align: 'center',
      width: 150,
    },
    {
      name: 'Đối tượng',
      fieldName: 'custType',
      isHideSort: true,
      align: 'center',
      width: 150,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {dataGet(record, 'custType') ? getJointSubjectSim(dataGet(record, 'custType')) : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Tên thuê bao',
      fieldName: 'subName',
      isHideSort: true,
      align: 'center',
      width: 200,
    },
    {
      name: 'Loại giấy tờ',
      fieldName: 'idType',
      isHideSort: true,
      width: 150,
      align: 'center',
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {getUcmCardTypeID(Number(dataGet(record, 'idType')))}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Số giấy tờ',
      fieldName: 'idNo',
      isHideSort: true,
      align: 'center',
    },
    {
      name: 'Trạng thái TB',
      fieldName: 'status',
      isHideSort: true,
      width: 150,
      align: 'center',
      renderSpecialCard: (record) => {
        if (Number(record.status)) {
          return <Typography.Text className='Text'>{'Đang hoạt động'}</Typography.Text>;
        } else {
          return <Typography.Text className='Text'>{'Đã huỷ'}</Typography.Text>;
        }
      },
    },
    {
      name: 'Trạng thái SIM',
      fieldName: 'activate',
      isHideSort: true,
      width: 180,
      align: 'center',
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>{getSimStatusBasic(record.activate)}</Typography.Text>
        );
      },
    },
    {
      name: 'Thao tác',
      fieldName: '',
      renderSpecialCard: (record) => {
        return (
          <Typography.Text
            className={`underline whitespace-nowrap cursor-pointer bg-transparent border-transparent ${
              hasPermission(PERMISSIONS.SUBSCRIBER.VIEW_DETAIL) ? 'text-blue-400' : 'text-gray-400'
            } font-semibold`}
            disabled={hasPermission(PERMISSIONS.SUBSCRIBER.VIEW_DETAIL)}
            onClick={() => handleDetailActiveSim(record)}
          >
            Chi tiết
          </Typography.Text>
        );
      },
    },
  ];

  const handleSearch = (formValues: FormData) => {
    const currentQueryStr = parseQueryString(location.search);
    delete currentQueryStr.pageIndex;
    delete currentQueryStr.pageSize;
    const { simType, statusSim, dateRange, goodCode, custType, statusIsdn } = formValues;
    const searchParams = {
      statusSim: statusSim === '-1' ? undefined : statusSim,
      simType: simType === '-1' ? undefined : simType,
      custType: custType === '-1' ? undefined : custType,
      statusIsdn: statusIsdn === '-1' ? undefined : statusIsdn,
      goodCode: goodCode === '-1' ? undefined : goodCode,
      pageIndex: 1,
      pageSize: dataGet(currentQueryStr, 'pageSize', 10),
      fromDate: dateRange ? dateRange[0].format('YYYY-MM-DD') : undefined,
      toDate: dateRange ? dateRange[1].format('YYYY-MM-DD') : undefined,
    };
    setSearchParams(queryString.stringify(searchParams));
    fetchActiveSimInfoData(searchParams as any);
  };

  const defaultValues = {
    goodCode: '',
    dateRange: [dayjs(), dayjs()],
    custType: '',
    simType: '',
    statusSim: '',
    statusIsdn: '',
  };

  const handleDetailActiveSim = (data: any) => {
    OpenNewTab(
      `active-sim/detail?serial=${data?.serial}&phone=${data?.isdn}`,
      `Chi tiết thuê bao ${data?.isdn ? '0' + data?.isdn : ''}`,
    );
  };

  const handleDeleteFilter = () => {
    form.resetFields();
    setSearchParams({});
  };

  const handleExport = () => {
    const searchParams = parseQueryString(location.search);
    const link = document.createElement('a');
    link.target = '_blank';
    link.download = `danh_sach_thue_bao_${moment().format('DDMMYYYYHHmmss')}.xlsx`;
    const url = '/api/user-profile/export-info-active-sim';
    exportExcelPost(url, searchParams)
      .then((res) => {
        message.success('Xuất file excel thành công');
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        link.click();
      })
      .catch((error) => {
        if (error.status === 403) {
          message.error(`Tài khoản của bạn không có quyền truy cập vào chức năng này`);
        }
      });
  };

  return (
    <>
      <div>
        <Form
          form={form}
          onFinish={handleSearch}
          initialValues={defaultValues}
          layout={size.width < 768 ? 'vertical' : 'inline'}
          className='gap-2'
        >
          <Form.Item
            name='dateRange'
            rules={[{ required: true, message: 'Vui lòng chọn ngày kích hoạt' }]}
            label={<div>Ngày kích hoạt</div>}
          >
            <DatePicker.RangePicker
              placeholder={['từ', 'đến']}
              format={['DD/MM/YYYY', 'DD/MM/YYYY']}
              className='min-w-[150px]'
              allowClear={false}
              placement={'bottomRight'}
              disabledDate={(current) => {
                return current.isAfter(dayjs());
              }}
            />
          </Form.Item>
          <Form.Item
            name='custType'
            rules={[{ required: true, message: 'Vui lòng chọn đối tượng' }]}
            label={<div>Đối tượng</div>}
          >
            <Select
              showSearch
              className='min-w-[150px]'
              filterOption={(input, option) => {
                return nonAccentVietnamese(
                  (option!.label as unknown as string).toString()?.toLowerCase(),
                ).includes(nonAccentVietnamese(input?.toLowerCase()?.trim()));
              }}
              options={getJointSubjectOption()}
            ></Select>
          </Form.Item>
          <Form.Item name='statusSim' label='Trạng thái SIM'>
            <Select
              showSearch
              className='min-w-[150px]'
              filterOption={(input, option) => {
                return nonAccentVietnamese(
                  (option!.label as unknown as string).toString()?.toLowerCase(),
                ).includes(nonAccentVietnamese(input?.toLowerCase()?.trim()));
              }}
              options={[{ label: 'Tất cả', value: '' }, ...getSimStatusOption()]}
            ></Select>
          </Form.Item>
          <Form.Item
            name='simType'
            label='Loại SIM'
            rules={[{ required: true, message: 'Vui lòng chọn loại sim' }]}
          >
            <Select
              showSearch
              className='min-w-[150px]'
              filterOption={(input, option) => {
                return nonAccentVietnamese(
                  (simTypeToText(option!.value) as unknown as string).toString()?.toLowerCase(),
                ).includes(nonAccentVietnamese(input?.toLowerCase()?.trim()));
              }}
            >
              <Option key={SimType.PHYSICAL_SIM} value={SimType.PHYSICAL_SIM}>
                {simTypeToText(SimType.PHYSICAL_SIM)}
              </Option>
              <Option key={SimType.ESIM} value={SimType.ESIM}>
                {simTypeToText(SimType.ESIM)}
              </Option>
            </Select>
          </Form.Item>

          <Form.Item name='goodCode' label='Gói cước ban đầu'>
            <Select
              showSearch
              className='min-w-[150px]'
              filterOption={(input, option) => {
                return nonAccentVietnamese(
                  (option!.value as unknown as string).toString()?.toLowerCase(),
                ).includes(nonAccentVietnamese(input?.toLowerCase()?.trim()));
              }}
              options={dataPackage}
            ></Select>
          </Form.Item>
          <Form.Item
            name='statusIsdn'
            rules={[{ required: true, message: 'Vui lòng chọn trạng thái thuê bao' }]}
            label={<div>Trạng thái thuê bao</div>}
          >
            <Select
              showSearch
              className='min-w-[150px]'
              filterOption={(input, option) => {
                return nonAccentVietnamese(
                  (option!.label as unknown as string).toString()?.toLowerCase(),
                ).includes(nonAccentVietnamese(input?.toLowerCase()?.trim()));
              }}
              options={listSubscriptionStatusOption()}
            ></Select>
          </Form.Item>
          <div className={'row-button justify-end flex-wrap mt-3'}>
            <Button onClick={() => handleDeleteFilter()} className={'m-1'}>
              Xóa tìm kiếm
            </Button>
            <Button type={'primary'} htmlType='submit' className={'m-1'}>
              Tìm kiếm
            </Button>

            {hasPermission(PERMISSIONS.SUBSCRIBER.EXPORT) && (
              <Button
                onClick={() => {
                  const { custType, statusIsdn, fromDate, toDate } = parseQueryString(
                    location.search,
                  );
                  if (custType && statusIsdn && fromDate && toDate) {
                    handleExport();
                  } else {
                    message.error('Vui lòng chọn đầy đủ thông tin tìm kiếm!');
                  }
                }}
                className={'m-1'}
              >
                Export
              </Button>
            )}
          </div>
        </Form>
      </div>
      <div className='mt-4'>
        {size.width < 1024 ? (
          <CGridView
            length={dataGet(dataSource, 'results', []).length}
            totalRecord={dataGet(dataSource, 'rowCount', 0) ?? 0}
            columns={columns}
            title={() => <div className='text-xl font-bold my-3'>Danh sách thuê bao</div>}
          >
            {dataGet(dataSource, 'results', []) && dataGet(dataSource, 'results', []).length > 0 ? (
              dataGet(dataSource, 'results', []).map((item: any) => {
                return (
                  <div key={'data-row-' + item.id_number}>
                    <Divider className='border-t-black' />

                    <Row className='mb-6 items-center' gutter={[4, 16]}>
                      {columns.map((ele) => {
                        if (ele.fieldName !== 'index' && ele.fieldName !== 'action') {
                          return (
                            <>
                              <Col span={11} className={`font-bold label`}>
                                <div className='flex gap-2 items-center'>{ele.name}</div>
                              </Col>
                              <Col className='break-words text-right' span={13}>
                                {ele?.renderSpecialCard
                                  ? ele?.renderSpecialCard(item, null, null, null)
                                  : item[`${ele?.fieldName}`]}
                              </Col>
                            </>
                          );
                        } else if (ele.fieldName === 'action') {
                          return (
                            <Col key={'column-' + item.id_number + ele.fieldName} span={24}>
                              <div className='flex gap-6'>
                                {ele?.renderSpecialCard
                                  ? ele?.renderSpecialCard(item, null, null, null)
                                  : item[`${ele?.fieldName}`]}
                              </div>
                            </Col>
                          );
                        } else {
                          return <></>;
                        }
                      })}
                    </Row>
                  </div>
                );
              })
            ) : (
              <p>{'Không có dữ liệu'}</p>
            )}
          </CGridView>
        ) : (
          <TableContent
            bordered
            // loading={isLoading}
            scroll={{ x: 'max-content' }}
            locale={{ emptyText: 'Không tìm thấy kết quả' }}
            totalRecord={dataGet(dataSource, 'rowCount', 0)}
            dataSource={dataGet(dataSource, 'results', [])}
            columns={columns}
            onPageChange={(pageNumber, pageSize) => {
              const pagination = parseQueryString(location.search);
              fetchActiveSimInfoData({
                ...pagination,
                pageIndex: pageNumber ?? 1,
                pageSize: pageSize ?? 10,
                sortField: pagination.fieldName ?? undefined,
                asc: pagination.orderType ?? undefined,
              });
            }}
            onSort={(sort: ISortColumn) => {
              const pagination = parseQueryString(location.search);
              handleSearch({
                ...pagination,
                pageIndex: pagination.pageIndex ?? 1,
                pageSize: pagination.pageSize ?? 10,
                sortField: sort.fieldName,
                asc:
                  sort.orderType === 'asc' ? true : sort.orderType === 'desc' ? false : undefined,
              });
            }}
          />
        )}
      </div>
    </>
  );
};

export default ActiveSim;
